import { render } from "./App.vue?vue&type=template&id=69a788f2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=69a788f2&lang=stylus"
script.render = render

export default script